import Request from '@/requests/Request'

const resource = "/projetos/{projetoId}/logica-intervencoes";

export default {
  findById(projetoId, logicaIntervencaoId) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.get(`${url}/${logicaIntervencaoId}`)
  },

  findByParentId(projetoId) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.get(url)
  },

  post(projetoId, logicaIntervencao) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.post(`${url}`, logicaIntervencao)
  },

  editar(projetoId, logicaIntervencao) {
    logicaIntervencao.projeto = null
    logicaIntervencao.itemStorage = null

    if(logicaIntervencao.logicaIntervencao) {
      logicaIntervencao.logicaIntervencao = null
    }

    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.put(`${url}/${logicaIntervencao.id}`, logicaIntervencao)
  },

  delete(projetoId, logicaIntervencaoId) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), projetoId)

    return Request.delete(`${url}/${logicaIntervencaoId}`)
  },

  ativarOuDesativarEdicao(payload) {
    let url = resource
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)
      const edicao = payload.edicao

    return Request.put(`${url}/${payload.logicaIntervencaoId}/editavel`, null, { params: { edicao } })
    //return Request.delete(`${resource}/${id}/removerParticipante`, { params: { participanteId } })


  },

}